<template>
  <div :class="{ 'is-sticking': isSticking }">
    <div v-if="!stickTo" ref="defaultGlue" style="position: fixed; top: 0" />

    <div
      class="sticky-wrapper"
      ref="wrapper"
      :style="{
                'z-index': isSticking ? zIndex : 'auto',
                width: isSticking ? stickyWidth + 'px' : 'auto',
                top: stickyTop + 'px',
            }"
    >
      <slot v-bind:isSticking="isSticking"/>
    </div>

    <div
      v-if="isSticking"
      class="placeholder w-full"
      ref="placeholder"
      :style="{
			height: placeholderHeight + 'px',
		}"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    stickTo: String,
    isSticky: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: Number,
      default: 30
    },
    additionalTopOffset: {
      type: Number,
      default: 0,
    }
  },

  data() {
    return {
      isSticking: false,
      stickyWidth: 0,
      stickyTop: 0,
      placeholderHeight: 0
    };
  },

  created() {
    this.check = () => {
      const shouldStick = this.isSticky && this.isScrolledPastTop();

      if (shouldStick && !this.isSticking) {
        this.placeholderHeight = this.$refs.wrapper.offsetHeight;
        this.isSticking = true;
      } else if (!shouldStick && this.isSticking) {
        this.isSticking = false;
      }

      this.$emit('sticking-changed', this.isSticking);
      
      if (this.isSticking) {
        this.updateWidth();
        this.updateTop();
      }
    };
  },

  mounted() {
    window.addEventListener("scroll", this.check);
    window.addEventListener("resize", this.check);

    this.check()
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.check);
    window.removeEventListener("resize", this.check);
  },

  methods: {
    isScrolledPastTop() {
      const stickToElement = this.getStickToElement();
      const detectorElement = this.getDetectorElement();

      const stickToElementTop = screenTop(stickToElement);
      const stickToElementBottom =
        Math.floor(stickToElementTop + stickToElement.offsetHeight) + this.additionalTopOffset;

      const detectorTop = screenTop(detectorElement);

      return stickToElementBottom > detectorTop;
    },

    getDetectorElement() {
      return this.isSticking ? this.$refs.placeholder : this.$refs.wrapper;
    },

    updateWidth() {
      const widthElement = this.$refs.placeholder || this.$refs.wrapper;
      this.stickyWidth = widthElement.offsetWidth;
    },

    updateTop() {
      const stickToElement = this.getStickToElement();
      const stickToElementTop = screenTop(stickToElement);
      this.stickyTop = Math.floor(stickToElementTop + stickToElement.offsetHeight) + this.additionalTopOffset;
    },

    getStickToElement() {
      return document.querySelector(this.stickTo) || this.$refs.defaultGlue;
    }
  }
};

function screenTop(element) {
  return Math.floor(element.getBoundingClientRect().top)
}
</script>

<style lang="scss" scoped>
.is-sticking .sticky-wrapper {
  position: fixed;
  top: 0;
  z-index: 30;
}
</style>